import { NgModule } from '@angular/core';
import { Ga4GgCartPageEventBuilder } from './ga4-gg-cart-page-event.builder';

declare module '@spartacus/core' {
  export interface Product {
    modelMark?: string;
    categoryHierarchy?: Category[] | undefined;
  }
}

@NgModule({})
export class Ga4GgCartPageEventModule {
  constructor(_ga4GgCartPageEventBuilder: Ga4GgCartPageEventBuilder) {}
}
